import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Modal from 'LuxKit/Modal/Modal'

function ExperienceInstantConfirmationModal() {
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'rLFfN0WH-VMt0VMjus1e',
        defaultMessage: 'Instant confirmation',
        description: 'Title for instant confirmation info modal on experience offer',
      })}
    >
      <BodyText className="full-width" variant="large">
        {intl.formatMessage({
          id: 'AjkhehjnTR4mD1rQuycp',
          defaultMessage: 'You will receive your booking confirmation email instantly after making your booking.',
          description: 'Description text explaining instant confirmation for experience offers',
        })}
      </BodyText>
    </Modal>
  )
}

export default ExperienceInstantConfirmationModal
